import React from "react";
import "./shyamala.css";
import img1 from "../../images/shyamala-big.jpg";
import Link from "gatsby-link";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
const icon1 = "https://www.winpeforum.com/assets/elements/shanti.jpg";
export class Shyamala extends React.Component {
  constructor(args) {
    super(args);
    this.state;
  }

  render() {
    const { location } = this.props;
    return (
      <ContentPage>
        <Meta
          title="Winpe ProClub Advisory Board | Shanti Ekambaram"
          description="Shanti Ekambaram is a distinguished banking business and governance leader with 39 years
of financial services experience, including an exceptional 35-year tenure at Kotak Mahindra

Bank where she was a part of the team that shaped the institution's transformation from a pre-
IPO non-banking financial company to one of India's most respected universal banks."
          image={
            "https://winpeforum.com/assets/elements/shanti.jpg"
          }
          location={location}
        />
        <div className="advisor-section">
          <div className="back_event">
            <Link to="/home/">
              <i className="fa fa-arrow-left"> Back</i>
            </Link>
          </div>
          <div className="container">
            <h1 className="heading text-center">Advisory Board</h1>
            <div className="advisor-section">
              <div className="row">
                <div className="col-md-12 content-section">
                  <img className="wrapper-image" src={icon1} alt="" />
                  <h1>Shanti Ekambaram</h1>
                  <h3>Former Deputy Managing Director & Whole-time Director</h3>
                  <h3>Strategic Transformation & Governance</h3>
                  <h3></h3>
                  <div className="para">
                    <p>
                     Shanti Ekambaram is a distinguished banking business and governance leader with 39 years
of financial services experience, including an exceptional 35-year tenure at Kotak Mahindra

Bank where she was a part of the team that shaped the institution's transformation from a pre-
IPO non-banking financial company to one of India's most respected universal banks. Her

career exemplifies the rare combination of, strategic vision, deep business orientation,
operational expertise and governance acumen that modern boards seek in their directors. <br/><br/>
Most recently serving as Deputy Managing Director and Whole-time Director (2022-2025),
Shanti provided strategic oversight across Treasury, Balance Sheet Management, Digital
Banking (811), Human Resources, Internal Audit, Vigilance, CSR/ESG, and Kotak's capital
market subsidiaries. In this role, she chaired the First Tier Audit Committee and POSH
Committee, demonstrating her commitment to financial integrity, regulatory compliance, and
organizational culture. Her stewardship during this period guided the Bank through external
markets volatility and regulatory transitions while delivering stakeholder value.<br/><br/>
Shanti's career is distinguished by her institution-building capabilities across multiple business
verticals and she has a unique blend of Corporate, Retail and Digital business experience..
As President of Consumer Banking (2014-2022), she led the strategic transformation of the
division through India's largest same-size bank merger—the integration of ING Vysya Bank—
while simultaneously pioneering digital banking innovation. The launch of 811 in March 2017,
India's first Aadhaar-enabled, zero-balance digital banking platform, required unprecedented
collaboration with regulators including RBI and UIDAI, establishing new paradigms for digital
onboarding that have since become industry standard. Her ability to navigate the regulatory
disruption of demonetization (November 2016) and position the Bank for accelerated digital
adoption demonstrated strategic agility and crisis leadership.<br/><br/>
Earlier, as President of Wholesale Banking (2003-2014), Shanti architected the business from
inception following Kotak's banking license acquisition. She established comprehensive
governance frameworks, risk policies, and compliance infrastructure across corporate
banking, SME, financial institutions, debt capital markets, custody, and transaction banking.
Her leadership during the 2008 global financial crisis—navigating through the Lehman
Brothers collapse with zero credit stress—validated her conservative risk philosophy and ,
protecting shareholder value during one of history's most turbulent financial periods.<br/><br/>
Perhaps most significantly for India's capital markets, Shanti served as CEO of Kotak
Mahindra Capital Company (1997-2003), the investment banking joint venture with Goldman
Sachs. She led a team that pioneered the transformation of India's equity capital markets by
leading the Hughes Software IPO in 1999—the country's first book-building transaction. This
landmark achievement required intensive collaboration with SEBI, investors, and market
participants to fundamentally reform IPO mechanisms, replacing archaic systems with global

standards. The governance frameworks and market practices that were established persist
today, demonstrating her capacity to drive systemic change through regulatory partnership
and industry leadership.<br/><br/>
Her leadership of Kotak's CSR and ESG strategy reflects values-driven decision-making that
extends beyond compliance to genuine stakeholder impact.<br/><br/>
A Chartered Accountant and Cost and Management Accountant, Shanti brings the business
expertise and technical financial expertise and audit committee qualifications that boards
require for oversight of complex financial institutions.<br/><br/>
She currently serves on the boards of Kotak Mahindra Capital Company, Kotak Securities,
and the Indian Institute of Management, Bangalore, where she contributes strategic direction
to India's premier business education institution.<br/><br/>
Beyond her professional achievements, Shanti's commitment to ESG and social impact is
deeply rooted and authentic. She has been involved at the founder level with SOPAN (Society
of Parents of Children with Autistic Disorders), an autism advocacy organization, and
consistently fundraises for social causes through her participation in the Mumbai Marathon.
Shanti's industry recognition underscores her standing as a preeminent business leader. She
was ranked No. 1 on the Candere Hurun India Women Leaders List 2025 and named
Businesswoman of the Year 2025 by The CEO Magazine. She has been consistently
recognized by Fortune India's '50 Most Powerful Women in Business' and Business Today's
'Most Powerful Women in Indian Business' throughout her career, reflecting sustained
excellence and impact.<br/><br/>
As she transitions to board director and strategic advisory roles post-retirement from Kotak
Mahindra Bank in October 2025, Shanti seeks opportunities where her extensive governance
expertise, financial acumen, regulatory navigation capabilities, and transformational
leadership can guide organizations through strategic inflection points.<br/><br/>
Shanti’s proven ability to build institutions, drive market innovation, navigate crises, and
maintain unwavering commitment to governance standards positions her as an exceptional
addition to boards seeking directors who combine strategic vision with fiduciary discipline and
genuine stakeholder orientation.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ContentPage>
    );
  }
}
Shyamala.propTypes = {
  location: PropTypes.object,
};

export default Shyamala;



// WEBPACK FOOTER //
// ./src/pages/shanti-ekambaram/index.jsx